module.exports = __webpack_public_path__ + "static/media/fuel_feb_2025.0ddc2a76.webp";